import React from 'react';
import { Helmet } from 'react-helmet';
import {
  COMPANY_DETAILS,
  PRODUCTION_SITE_URL,
  SOCIAL_LINKS,
  SUPPORT_EMAIL,
} from '../../../../AppConstants';

const { LEGAL_NAME, COMPANY_NUMBER, STREET_ADDRESS, LOCALITY, POSTCODE } =
  COMPANY_DETAILS;

// Built from the production URL, not the page's origin, so test and preview
// deployments describe the same organisation as swimbooker.com.
const schema = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: 'swimbooker',
  legalName: LEGAL_NAME,
  url: PRODUCTION_SITE_URL,
  logo: `${PRODUCTION_SITE_URL}/apple-touch-icon.png`,
  identifier: COMPANY_NUMBER,
  address: {
    '@type': 'PostalAddress',
    streetAddress: STREET_ADDRESS,
    addressLocality: LOCALITY,
    postalCode: POSTCODE,
    addressCountry: 'GB',
  },
  contactPoint: {
    '@type': 'ContactPoint',
    contactType: 'customer support',
    email: SUPPORT_EMAIL,
    areaServed: 'GB',
    availableLanguage: 'English',
  },
  sameAs: Object.values(SOCIAL_LINKS),
};

function OrganisationSchema() {
  return (
    <Helmet>
      <script type='application/ld+json'>{JSON.stringify(schema)}</script>
    </Helmet>
  );
}

export default OrganisationSchema;
